<template>
  <div class="archives-tab">
    <div class="filters-card card">
      <div class="filters">
        <VField
          class="light"
          placeholder="Recherche"
          name="search"
          icon="bi-search"
          v-model="state.search.value"
          @input="(event) => (state.search.value = event.target.value)"
        />
      </div>
    </div>
    <div class="card">
      <h4>Liste de vos campagnes archivées</h4>
      <p>
        Ci-dessous, retrouvez vos campagnes archivées. Vous pouvez les restaurer
        à tout moment.
      </p>
      <Table
        :data="campaignStore.archivedCampaigns"
        :fields="state.fields"
        :search="state.search"
      >
        <template #completion="{ data }">
          {{
            data.total_evaluated_participants === 0
              ? "0%"
              : `${
                  data.total_participants / data.total_evaluated_participants
                }%`
          }}
        </template>
        <template #actions="actionsProps">
          <Button
            label="Restaurer la campagne"
            class="icon icon-left primary"
            icon="bi-gear"
            :loading="state.btnIsLoading"
            @click="restore(actionsProps.row)"
          />
        </template>
        <template #empty>
          <Empty
            message="<b>Aucune campagne</b> n’a été archivée pour le moment."
            :dark="isDark"
            icon="folder"
          />
        </template>
      </Table>
    </div>
    <ActionModal
      modal="restore"
      :data="state.selectedCampaign"
      :isOpen="state.showActionModal"
      @close="state.showActionModal = false"
      @confirm="state.showActionModal = false"
    />
  </div>
</template>

<script setup>
import { reactive } from "vue";
import { useRoute } from "vue-router";
import { useDark } from "@vueuse/core";
import { useCampaignStore } from "@/stores/campaign.js";
import Empty from "@/components/table/Empty.vue";
import ActionModal from "@/components/modals/app/actionModal/ActionModal.vue";

const campaignStore = useCampaignStore();

const isDark = useDark();

const route = useRoute();

const state = reactive({
  btnIsLoading: false,
  showActionModal: false,
  selectedCampaign: {},
  search: {
    value: "",
    searchable: ["campaign.name"],
  },
  fields: [
    {
      id: "campaign.name",
      label: "Nom de la campagne",
      sort(a, b, dir) {
        if (dir === "ASC") return a.localeCompare(b);
        return b.localeCompare(a);
      },
    },
    {
      id: "total_participants",
      label: "Nb total de participants",
      defaultSortDir: "DESC",
      sort(a, b, dir) {
        if (dir === "ASC") return a - b;
        return b - a;
      },
    },
    {
      id: "total_evaluated_participants",
      label: "Nb de talents évalués",
      sort(a, b, dir) {
        if (dir === "ASC") return a - b;
        return b - a;
      },
    },
    {
      id: "completion",
      label: "% de complétion de la campagne",
      multipleSort: true,
      sort(a, b, dir) {
        const pourcA =
          a.total_evaluated_participants === 0
            ? 0
            : a.total_participants / a.total_evaluated_participants;

        const pourcB =
          b.total_evaluated_participants === 0
            ? 0
            : b.total_participants / b.total_evaluated_participants;
        if (dir === "ASC") return pourcA - pourcB;
        return pourcB - pourcA;
      },
    },
  ],
});

await campaignStore.getArchivedCampaigns(route.params.companyId);

function restore(campaign) {
  state.selectedCampaign = campaign;
  state.showActionModal = true;
}
</script>
